import { render, staticRenderFns } from "./kontaktDetail.vue?vue&type=template&id=53c1bee0&scoped=true&"
import script from "./kontaktDetail.vue?vue&type=script&lang=js&"
export * from "./kontaktDetail.vue?vue&type=script&lang=js&"
import style0 from "./kontaktDetail.vue?vue&type=style&index=0&id=53c1bee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c1bee0",
  null
  
)

export default component.exports